//====================================================
//  Initialization Accordion
//====================================================
function fn_components_counter(){
	if ($('.count-stats').length){
		var waypoint = new Waypoint({
			element: document.getElementById('stats-trigger'),
			handler: function(direction) {
				$('.count-stats').each(function () {
				    $(this).prop('Counter',0).animate({
				        Counter: $(this).data('count')
				    }, {
				        duration: 2000,
				        easing: 'swing',
				        step: function (now) {
			/*	        	// if (Math.ceil(now) > 10){
				            	$(this).text(Math.ceil(now));
				        	// } else {
				         //    	$(this).text('0' + Math.ceil(now));
				        	// }*/
				            $(this).text(Math.ceil(now));
				        }
				    });
				});
				this.destroy();
		  	},
 			offset: '80%'
		})
	}
}

